import { Sidebar } from '../Sidebar/Sidebar';
import { Box, Stack, styled } from '@razz-team/ui-web';
import { AppLayout } from './AppLayout';

const Content = styled(Box)({
  width: '100%',
});

export function AccountLayout({ children }: { children: React.ReactNode }) {
  return (
    <AppLayout>
      <Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} width="100%" height="100%">
        <Sidebar />
        <Content>{children}</Content>
      </Stack>
    </AppLayout>
  );
}
